import { morph } from "@theme/morph";
import { Component } from "@theme/component";
import {
  CartUpdateEvent,
  ThemeEvents,
  VariantSelectedEvent,
} from "@theme/events";
import { DialogComponent, DialogCloseEvent } from "@theme/dialog";
import {
  mediaQueryLarge,
  isMobileBreakpoint,
  getIOSVersion,
} from "@theme/utilities";
import VariantPicker from "@theme/variant-picker";
import { AddToCartComponent, ProductFormComponent } from "@theme/product-form";

/**
 * Custom code: option quick add
 *
 * @typedef {Object} Refs
 * @property {HTMLScriptElement} quantityMins
 * @property {ProductFormComponent} productForm
 *
 * @extends {Component<Refs>}
 */
export class OptionQuickAddComponent extends Component {
  requiredRefs = ["quantityMins", "productForm"];

  /** @type {AbortController | null} */
  #abortController = null;
  /** @type {Map<string, Element>} */
  #cachedContent = new Map();
  /** @type {AbortController} */
  #cartUpdateAbortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate, {
      signal: this.#cartUpdateAbortController.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController?.abort();
    this.#cartUpdateAbortController.abort();
  }

  #handleCartUpdate = () => {
    // Success?
  };

  /**
   * Handles quick add button click
   * @param {MouseEvent} event - The click event
   */
  handleClick = async (event) => {
    event.preventDefault();
    if (!(event.target instanceof HTMLButtonElement)) return;

    const variantId = event.target.dataset.variantId;
    if (!variantId) return;

    let minQuantity = "1";
    try {
      minQuantity =
        JSON.parse(this.refs.quantityMins.innerText)?.[variantId] || "1";
    } catch (error) {
      console.error(error);
    }

    this.refs.productForm.refs.variantId.value = variantId;

    const quantitySelector = /** @type {any | undefined} */ (
      this.refs.productForm.querySelector("[name='quantity']")
    );

    if (quantitySelector) {
      quantitySelector.value = "1";
    }

    this.refs.productForm.handleSubmit(event);

    const addToCartComponent = /** @type {AddToCartComponent | null} */ (
      event.target.closest("add-to-cart-component")
    );

    addToCartComponent?.handleClick(
      /** @type {MouseEvent & {target: HTMLElement}} */ (event),
    );
  };
}

if (!customElements.get("option-quick-add-component")) {
  customElements.define("option-quick-add-component", OptionQuickAddComponent);
}

// class QuickAddDialog extends DialogComponent {
//   #abortController = new AbortController();

//   connectedCallback() {
//     super.connectedCallback();

//     this.addEventListener(ThemeEvents.cartUpdate, this.handleCartUpdate, { signal: this.#abortController.signal });
//     this.addEventListener(ThemeEvents.variantUpdate, this.#updateProductTitleLink);

//     this.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     this.#abortController.abort();
//     this.removeEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
//   }

//   /**
//    * Closes the dialog
//    * @param {CartUpdateEvent} event - The cart update event
//    */
//   handleCartUpdate = (event) => {
//     if (event.detail.data.didError) return;
//     this.closeDialog();
//   };

//   #updateProductTitleLink = (/** @type {CustomEvent} */ event) => {
//     const anchorElement = /** @type {HTMLAnchorElement} */ (
//       event.detail.data.html?.querySelector('.view-product-title a')
//     );
//     const viewMoreDetailsLink = /** @type {HTMLAnchorElement} */ (this.querySelector('.view-product-title a'));
//     const mobileProductTitle = /** @type {HTMLAnchorElement} */ (this.querySelector('.product-header a'));

//     if (!anchorElement) return;

//     if (viewMoreDetailsLink) viewMoreDetailsLink.href = anchorElement.href;
//     if (mobileProductTitle) mobileProductTitle.href = anchorElement.href;
//   };

//   #handleDialogClose = () => {
//     const iosVersion = getIOSVersion();
//     /**
//      * This is a patch to solve an issue with the UI freezing when the dialog is closed.
//      * To reproduce it, use iOS 16.0.
//      */
//     if (!iosVersion || iosVersion.major >= 17 || (iosVersion.major === 16 && iosVersion.minor >= 4)) return;

//     requestAnimationFrame(() => {
//       /** @type {HTMLElement | null} */
//       const grid = document.querySelector('#ResultsList [product-grid-view]');
//       if (grid) {
//         const currentWidth = grid.getBoundingClientRect().width;
//         grid.style.width = `${currentWidth - 1}px`;
//         requestAnimationFrame(() => {
//           grid.style.width = '';
//         });
//       }
//     });
//   };
// }

// if (!customElements.get('quick-add-dialog')) {
//   customElements.define('quick-add-dialog', QuickAddDialog);
// }
